<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
	import {
		getConfig
	} from '@/api/reqFetch.js'
	export default {
		data() {
			return {
				isGrayTime:false
			}
		},
		created() {
			getConfig().then(res => {
				// res.data.map(item=>{
				// 	// if(item.configKey == 'cms_website_title'){
				// 	// 	document.title = item.configValue
				// 	// 	localStorage.setItem('webTitle',item.configValue)
				// 	// }
					
				// 		document.title = item.cms_website_title.configValue
				// 		localStorage.setItem('webTitle',item.cms_website_title.configValue)
					
				// })
				document.title = res.data.cms_website_title.configValue
				localStorage.setItem('webTitle',res.data.cms_website_title.configValue)
				
			})
			
			
		}
	}
</script>

<style>
	ul li {
	margin: 0px;
	padding: 0px;
	list-style-type: none;
}
	
	@import "../html/css/master.css";
	@import "../html/css/css.css";
	@import "../html/css/css2.css";
	@import "../html/css/mobile.css";
	@import "../html/css/reset.css";
	@import "../html/css/style.css";
</style>
